const AppConfigMapFile = require('./AppConfig.json');

export enum AppConfigMapKey {
    PO_REDIRECT_MAPPING = "poRedirectMapping",
    SHIPMENT_REDIRECT_MAPPING = "shipmentRedirectMapping",
    REQUEST_ID_REDIRECTION_MAPPING = "requestIdRedirectionMapping",
    IS_WOS_CHART_ENABLED = "isWOSChartEnabled",
    UIP_PAGE_CONFIG_URL = "uipPageConfigUrl",
    WOC_PAGE_CONFIG_URL = "wocPageConfigUrl",
    UIP_SAVE_PAGE_CONFIG_URL = "uipSavePageConfigUrl",
    IS_STAGE_PROD = "isStageProd"
}

export class AppConfig{

    private static readonly frameworkStage = (window as any).ARGO_CONFIG?.argo?.frameworkStage;
    private static readonly cellInfo = (window as any).ARGO_CONFIG?.argo?.cell;
    private static readonly configStageKey = AppConfig.frameworkStage + '.' + AppConfig.cellInfo;

    private static readonly CONFIG = AppConfigMapFile;

    /**
     *
     * @param configMap
     * @private
     */
    private constructor(public readonly configMap: Map<string, Map<string,string>>) {
    }

    public static getConfigValue(configKey: AppConfigMapKey) {
        const value = AppConfig.CONFIG[this.configStageKey] ? AppConfig.CONFIG[this.configStageKey][configKey.toString()] : AppConfig.CONFIG["localhost"][configKey.toString()];
        return value == undefined ? null : value;
    }

    public static logConfigStageKey(): string {
        return this.configStageKey;
    }
}